module.exports = __webpack_public_path__ + "static/media/house_daytime.cc6addcb.png";